import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module,
  RecaptchaModule
} from "ng-recaptcha";

import { CommonModule } from "@angular/common";
import { LoginComponent } from "./login.component";

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    RecaptchaModule,
    RecaptchaV3Module,
    ReactiveFormsModule,
    RouterModule.forChild([{ path: "", component: LoginComponent }])
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: "6LcmQ6gUAAAAABFqOWPb60aWVYXRboI_is0b76Lg"
    }
  ]
})
export class LoginModule {}
